import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;

export const ContractStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const TocContainer = styled.div`
  margin: 24px 0;
`;
